import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PuffLoader } from 'react-spinners';
import './preloader.scss';
import axios from 'axios';
// import { actionLogTrack } from '../../lib/logs';
import { Toastify } from 'lift-ui';
import { actionLogTrack } from '@lift-admin/utils/actionLogTrack';
import apiClient from '@lift-admin/utils/apiClient';
import { useAuthContext } from '@lift-admin/utils/provider';
const AdminRedirect = () => {
  const super_admin = localStorage.getItem('super_admin')
    ? JSON.parse(localStorage.getItem('super_admin') || '')
    : null;

  const searchParams = new URLSearchParams(window.location.search);

  const redirectToken = searchParams.get('redirectToken');

  const navigate = useNavigate();
  const { SSOSignIn, authUser } = useAuthContext();

  // Guard against duplicate SSO sign-ins. React 18 StrictMode double-invokes
  // effects on mount (dev), which would otherwise trigger the login flow — and
  // its "logged in" admin log — twice for the same redirect token.
  const hasSignedInRef = useRef(false);

  useEffect(() => {
    if (redirectToken && !hasSignedInRef.current) {
      hasSignedInRef.current = true;
      SSOSignIn(redirectToken);
    }
  }, [redirectToken]);

  useEffect(() => {
    if (authUser && super_admin) {
      console.log(authUser, 'authUser');

      navigate('/home', {
        state: {
          email: authUser.email,
          is_admin: 1,
        },
      });
    }
  }, [authUser, super_admin]);

  return (
    <div className="preloader">
      <PuffLoader
        className="puff-loader-preloader"
        size={80}
        color="rgba(22, 48, 109, 1)"
        speedMultiplier={0.8}
      />
    </div>
  );
};

export default AdminRedirect;
